import React from "react";
import logo from "./rasilniFavicon.png";

function RasilniIcon({ height, width }) {
  return <img src={logo} height={height} width={width} alt="Rasilni Logo" />;
}

export default RasilniIcon;
